import type { ConflictingElementInfo } from '@empathyco/playboard-core-domain'
import type Router from 'vue-router'

export class ConflictErrorsUtils {
  static buildLinkToUpdateConflictingElement(
    $router: Router,
    routeName: string,
    conflictingElement: ConflictingElementInfo,
  ): HTMLAnchorElement {
    const route = $router.resolve({
      name: routeName,
      params: { id: conflictingElement.id },
    })
    const link = document.createElement('a')
    link.href = route.href
    link.target = '_blank'
    link.innerText = conflictingElement.name ?? conflictingElement.id
    return link
  }

  static buildLinksToUpdateConflictingElements(
    $router: Router,
    routeName: string,
    conflictingElements: ConflictingElementInfo[],
  ): HTMLAnchorElement[] {
    return conflictingElements.map(conflictingElement =>
      this.buildLinkToUpdateConflictingElement($router, routeName, conflictingElement),
    )
  }
}
